module.exports = __webpack_public_path__ + "img/horizontal_4_5_r_pp2_0.0180acec.png";